import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Link } from 'react-router-dom';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
import Checkbox from '@material-ui/core/Checkbox';

// @material-ui/icons
import Face from '@material-ui/icons/Face';
import Email from '@material-ui/icons/Email';
// import LockOutline from "@material-ui/icons/LockOutline";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import Check from '@material-ui/icons/Check';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import Auth from 'services/AuthService';
import logo from 'assets/img/fynda.png';

import GoogleLoginImg from 'assets/img/googlelogin.png';
import loginPageStyle from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx';

const Transition = (props) => {
  return <Slide direction='down' {...props} />;
};

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      passwordNotice: null,
      updateSignUpModal: false,
      updateLogInModal: false,
      authInfo: {
        email: '',
        password: '',
      },
    };
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
    });
  };

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };

  handleSubmitSignUp = (e) => {
    e.preventDefault();

    if (this.state.authInfo.password !== this.state.authInfo.confirmPassword) {
      this.setState({
        passError: true,
      });
      return;
    }

    if (this.state.checked[0] !== 'accepted terms') {
      this.setState({
        termsError: true,
      });
      return;
    }

    this.setState({
      signupError: false,
    });

    Auth.emailSignup(this.state.authInfo);
  };

  handleSubmitLogIn = (e) => {
    e.preventDefault();
    Auth.emailSignIn(this.state.authInfo);
  };

  handleChange = (e) => {
    this.setState({
      ...this.state,
      authInfo: {
        ...this.state.authInfo,
        [e.target.id]: e.target.value,
      },
    });
  };

  handlePasswordReset = (e) => {
    e.preventDefault();
    Auth.passwordReset(this.state.authInfo.email);
    this.setState({
      ...this.state,
      passwordNotice: 'Password reset link sent. Please check your email.',
    });
  };

  render() {
    const { authError, classes } = this.props;
    const { passwordNotice } = this.state;

    return (
      <div className={classes.container}>
        <GridContainer justify='center'>
          <GridItem
            xs={8}
            sm={6}
            md={4}
            className={classes.formContainer}
            style={{ margin: '3% 0 0 0' }}
          >
            <img src={logo} alt='logo' className={classes.img} />
            <br />
            <br />
            {/* <p className={classes.subdescription}><strong>The Best Way To Discover New Music!</strong></p> */}
            <br />
            <Link to='/pages/signup-page'>
              <Button
                style={{
                  textTransform: 'uppercase',
                  borderRadius: '50px',
                  backgroundColor: '#A683FC',
                  width: '100%',
                }}
              >
                <b>Create An Account</b>
              </Button>
            </Link>
            <br />
            <Button
              style={{
                textTransform: 'uppercase',
                borderRadius: '50px',
                backgroundColor: '#4557DB',
                width: '100%',
              }}
              onClick={() => this.handleClickOpen('updateLogInModal')}
            >
              <b>Log In</b>
            </Button>
            <img
              src={GoogleLoginImg}
              style={{
                width: '100%',
                padding: '0px',
                margin: '0 auto',
                marginTop: '20px',
              }}
              onClick={Auth.googleLogin}
              alt='Google log in'
            />

            {/* UPDATE LOG IN MODAL */}
            <Dialog
              classes={{
                root: classes.modalRoot,
                paper: classes.modal + ' ' + classes.modalSmall,
              }}
              open={this.state.updateLogInModal}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => this.handleClose('updateLogInModal')}
              aria-labelledby='shipment-modal-slide-title'
              aria-describedby='shipment-modal-slide-description'
            >
              {/*<DialogTitle
                id="shipment-modal-slide-title"
                disableTypography
                className={classes.modalHeader}
              >
                <Button
                  simple
                  className={classes.modalCloseButton}
                  key="close"
                  aria-label="Close"
                  onClick={() => this.handleClose("updateLogInModal")}
                >
                  {" "}
                  <Close className={classes.modalClose} />
                </Button>
                <h2 className={classes.modalTitle}>EDIT PROFILE</h2>
              </DialogTitle>*/}
              <DialogContent
                id='shipment-modal-slide-description'
                className={classes.modalBody}
              >
                {/* FORM */}
                <form onSubmit={this.handleSubmitLogIn}>
                  <Card login className={classes[this.state.cardAnimaton]}>
                    <CardBody>
                      <p className={classes.textCenter}>
                        New?{' '}
                        <Link
                          to='/pages/signup-page'
                          className={classes.linkText}
                        >
                          Create an account now.
                        </Link>
                      </p>
                      <CustomInput
                        labelText='Email'
                        id='email'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          endAdornment: (
                            <InputAdornment position='end'>
                              <Email />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <CustomInput
                        labelText='Password'
                        id='password'
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: this.handleChange,
                          type: 'password',
                          endAdornment: (
                            <InputAdornment position='end'>
                              <Icon>lock_outline</Icon>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {authError ? (
                        <div className={classes.justifyContentCenter}>
                          <p className={classes.textDanger}>
                            Error: {authError.message}
                            <br />
                            Forgot your password?
                          </p>
                          <Button
                            type='button'
                            onClick={this.handlePasswordReset}
                            color='danger'
                            simple
                            size='lg'
                            block
                          >
                            Click Here
                          </Button>
                          <p className={classes.textDanger}>
                            to send a password reset email.
                          </p>
                        </div>
                      ) : null}
                      {passwordNotice ? (
                        <p className={classes.textDanger}>{passwordNotice}</p>
                      ) : null}
                    </CardBody>
                    <CardFooter className={classes.justifyContentCenter}>
                      <Button type='submit' color='primary'>
                        Let's Go
                      </Button>
                    </CardFooter>
                  </Card>
                </form>{' '}
                <Button
                  className={classes.ltrButtonWhite}
                  style={{
                    marginLeft: '10px',
                    marginTop: '10px',
                  }}
                  key='close'
                  aria-label='Close'
                  onClick={() => this.handleClose('updateLogInModal')}
                >
                  CLOSE
                </Button>
              </DialogContent>
            </Dialog>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    authError: state.error,
  };
};

export default compose(
  connect(mapStateToProps),
  withStyles(loginPageStyle)
)(LoginPage);
